import { Product } from "../../../types/Shop";
import { functions } from "../../firebase";
export const updateProduct = async (params: { communityId: string; product: Product }): Promise<void> => {
  const result = await functions.httpsCallable("saveShopProduct")(params);
  void result;
};
